module.exports = __webpack_public_path__ + "img/vvpNiI-Y.8b7fe10d.gif";